import React, { useEffect, useMemo, useState } from 'react';
import { DemeterUnmappedFinancialInstrumentModel } from '../../../../Generated/Raven-Demeter';
import Table from '../../../Components/Tables/Table/Table';
import { ApiListResponse } from '../../../Components/Tables/TableWrapper/ApiListResponse';
import Pagination from '../../../Components/Tables/TableWrapper/Pagination';
import useLanguage from '../../../Services/Language/useLanguageHook';
import styles from './MurexInstrumentMappingPage.module.scss';
import { getUnmappedFinancialInstrumentColumnDefinitions } from './MurexInstrumentMappingPageDefinitions';

interface IUnmappedFinancialInstrumentsTableProps {
    unmappedInstruments: DemeterUnmappedFinancialInstrumentModel[];
    isLoading: boolean;
    handleMurexInstrumentKeySelected: (murexDerivedInstrumentKey: string) => void;
}

const trackingCategory = 'MurexInstrumentMapping';
const defaultItemsPerPage = 50;

const UnmappedFinancialInstrumentsTable: React.FC<IUnmappedFinancialInstrumentsTableProps> = (props: IUnmappedFinancialInstrumentsTableProps) => {
    const [translations] = useLanguage();

    const [itemsPerPage, setItemsPerPage] = useState<number>(defaultItemsPerPage);
    const [skip, setSkip] = useState<number>(0);

    const tableHeaders = useMemo(
        () => getUnmappedFinancialInstrumentColumnDefinitions(props.handleMurexInstrumentKeySelected),
        [props.handleMurexInstrumentKeySelected],
    );

    useEffect(() => {
        setSkip(0);
    }, [props.unmappedInstruments]);

    const pageRows = useMemo(() => props.unmappedInstruments.slice(skip, skip + itemsPerPage), [props.unmappedInstruments, skip, itemsPerPage]);

    const paginationListResponse: ApiListResponse = { totalCount: props.unmappedInstruments.length, take: itemsPerPage, skip };

    return (
        <div className={styles.murex_instrument_mapping_unmapped_container}>
            <h3>{translations.murexInstrumentMapping.text.unmappedInstrumentsHeader}</h3>
            {!props.isLoading && props.unmappedInstruments.length === 0 ? (
                <div className={styles.murex_instrument_mapping_selection_hint}>{translations.murexInstrumentMapping.text.noUnmappedInstruments}</div>
            ) : (
                <div className={styles.murex_instrument_mapping_table_container}>
                    <Table tableHeaders={tableHeaders} tableData={pageRows} tableStyle="alternatingRows" isLoading={props.isLoading} />
                    {props.unmappedInstruments.length > itemsPerPage && (
                        <Pagination
                            apiListResponse={paginationListResponse}
                            handlePagination={(updatedPagination) => setSkip(updatedPagination.skip ?? 0)}
                            handleTakeCountUpdate={(updatedTakeCount) => {
                                setItemsPerPage(updatedTakeCount.take ?? defaultItemsPerPage);
                                setSkip(0);
                            }}
                            track={{ eventCategory: trackingCategory, eventAction: 'UnmappedInstrumentsPaginationChanged' }}
                        />
                    )}
                </div>
            )}
        </div>
    );
};

export default UnmappedFinancialInstrumentsTable;
